module.exports = __webpack_public_path__ + "static/media/woman.3c99c1f9.svg";